import { DEFAULT_TABLE_PAGE_SIZE } from 'shared/constants/pagination'

export const ROWS_PER_PAGE_OPTIONS = [DEFAULT_TABLE_PAGE_SIZE, 25, 50]
